export default {
  title: 'Employees',
  description: 'Everyone in the company — phones to pair, and who can sign in to this portal.',
  inviteByEmail: 'Invite by email',
  newEmployee: 'New employee',
  searchPlaceholder: 'Search by name or number…',
  searchLabel: 'Search employees',
  showInactive: 'Show inactive',
  inviteSelected: 'Invite {count} selected',
  summaryOne: '{count} person · {paired} paired',
  summaryOther: '{count} people · {paired} paired',
  notResponding: '{count} not responding',
  emptySearchTitle: 'No one matches',
  emptyTitle: 'No employees yet',
  emptySearchMessage: 'Nothing matches "{search}".',
  emptyMessage: 'Add the people who carry company phones, then pair each phone with a PIN.',
  selectAllInvitable: 'Select everyone who hasn\'t set up a phone',
  selectEmployee: 'Select {name}',
  colEmployeeNumber: 'Employee #',
  colRole: 'Role',
  colPortal: 'Portal',
  colLastActive: 'Last active',
  colDevice: 'Device',
  colLastSeen: 'Last seen',
  colPermissions: 'Permissions',
  noRole: 'No role',
  portalAdmin: 'Admin',
  portalSiteManager: 'Site manager',
  never: 'Never',
  pinPending: 'PIN pending',
  invited: 'Invited',
  inviteExpiredTooltip: 'The invite link expired. Resend it.',
  inviteExpired: 'Invite expired',
  notPaired: 'Not paired',
  active: 'Active',
  inactive: 'Inactive',
  invite: 'Invite',
  resendInvite: 'Resend invite',
  pair: 'Pair',
  unpair: 'Unpair',
  deactivate: 'Deactivate',
  reactivate: 'Reactivate',
  deactivateTitle: 'Deactivate employee',
  deactivateMessage: '"{name}" will no longer be able to pair or sync a device. Attendance history is kept.',
  deactivated: 'Employee deactivated.',
  reactivated: 'Employee reactivated.',
  inviteSentOne: '{count} invite sent.',
  inviteSentOther: '{count} invites sent.',
  inviteTitleOne: 'Invite {name}',
  inviteTitleMany: 'Invite {count} employees',
  inviteTitlePaste: 'Invite people by email',
  inviteDescription: 'They get an email with a link that installs the app and pairs their phone. No codes to type and no password to set.',
  inviteResultSent: '{sent} sent',
  inviteResultWithFailed: '{sent} sent, {failed} need attention',
  noEmail: 'No email',
  noEmailLower: 'no email',
  inviteAddedAndSent: 'Added and sent',
  inviteSent: 'Sent',
  inviteNotSent: 'Not sent',
  emailFor: 'Email for {name}',
  emailPlaceholder: 'name@example.com',
  peopleToInvite: 'People to invite',
  invitePlaceholder: 'Jane Doe, jane@example.com, Electrician\nSam Smith <sam@example.com>\nlee@example.com',
  inviteHelp: 'One person per line: name, email, and optionally role. Pasting straight from a spreadsheet works too.',
  missingSkippedOne: '{count} without an email will be skipped.',
  missingSkippedOther: '{count} without an email will be skipped.',
  sending: 'Sending…',
  sendInvitesOne: 'Send {count} invite',
  sendInvitesOther: 'Send {count} invites',
  sendInvites: 'Send invites',
  pairTitle: 'Pair {name}',
  pairDescription: 'Generate a one-time PIN and enter it in the CrewPresence app on the employee’s phone.',
  phonePairedToast: 'Phone paired.',
  phonePaired: 'Phone paired',
  phonePairedMessage: 'This phone will now report site presence for {name}.',
  pinExpired: 'This PIN has expired',
  expiresIn: 'Expires in <time>{time}</time>',
  pinInstructions: 'Open CrewPresence on the phone and enter this PIN. The dialog updates itself the moment the phone pairs.',
  generating: 'Generating…',
  newPin: 'New PIN',
  alreadyPairedWarning: 'This employee already has a paired phone. When a new phone pairs with this PIN, the current phone is signed out straight away: it stops recording attendance and has to be paired again.',
  generatePairingPin: 'Generate pairing PIN',
  replaceTitle: 'Replace current phone?',
  replaceMessage: 'This employee already has a paired phone. Once a new phone pairs with this PIN, the current phone is signed out immediately and stops recording attendance. Only continue if you are replacing it.',
  generatePin: 'Generate PIN',
  unpairedToast: '{name}\'s phone was unpaired.',
  unpairTitle: 'Unpair {name}\'s phone',
  unpairDescription: 'Enter the company\'s unpair passcode to confirm. This immediately stops the phone from syncing attendance for this employee.',
  unpairPasscode: 'Unpair passcode',
  unpairPlaceholder: 'e.g. 4471',
  unpairing: 'Unpairing…',
  unpairPhone: 'Unpair phone',
  employmentFullTime: 'Full-time',
  employmentPartTime: 'Part-time',
  employmentCasual: 'Casual',
  employmentContractor: 'Contractor',
  employmentApprentice: 'Apprentice',
  employmentLabourHire: 'Labour hire',
  roleCarpenter: 'Carpenter',
  roleElectrician: 'Electrician',
  roleLabourer: 'Labourer',
  roleSiteSupervisor: 'Site Supervisor',
  rolePlantOperator: 'Plant Operator',
  fullName: 'Full name',
  employeeNumber: 'Employee number',
  employeeNumberHint: 'Must be unique within the company. Leave it blank on a new employee and the next number is generated.',
  employeeNumberAuto: 'Generated when left blank',
  roleHint: 'Optional. Shown on the employee page.',
  rolePlaceholder: 'e.g. Carpenter',
  emailHintPortal: 'Their portal sign-in, and where the app invite is sent.',
  emailHintOptional: 'Optional. Used to email the app invite. You can also invite from the employee list.',
  manager: 'Manager',
  managerHint: 'Approves this person\'s shift-swap requests.',
  noManager: 'No manager',
  secondaryManager: 'Secondary manager',
  portalAccess: 'Portal access',
  canSignIn: 'Can sign in to the portal',
  setPasswordNow: 'Set a password now',
  inviteByEmailNote: 'We\'ll email them a link to choose their own password. It expires in a week.',
  password: 'Password',
  newPassword: 'New password',
  passwordHintNew: 'At least 10 characters.',
  passwordHintKeep: 'Leave blank to keep the current password.',
  portalRole: 'Portal role',
  portalRoleHint: 'Admins see everything; site managers only their sites.',
  sites: 'Sites',
  sitesHint: 'Which sites this person manages.',
  noSites: 'No sites yet.',
  employment: 'Employment',
  employmentType: 'Employment type',
  contractorLeaveHint: "Contractors don't earn leave. If they report sick it is recorded as a notice of absence, not paid leave.",
  notSet: 'Not set',
  contractType: 'Contract type',
  department: 'Department',
  primarySite: 'Primary site',
  startDate: 'Start date',
  probationEnds: 'Probation ends',
  noticePeriod: 'Notice period (days)',
  personal: 'Personal',
  mobile: 'Mobile',
  dateOfBirth: 'Date of birth',
  homeAddress: 'Home address',
  activeCheckbox: 'Active. Can pair a phone and sync attendance',
  liveTracking: 'Live position tracking',
  liveTrackingCheckbox: 'Show this employee\'s position on the site map while they\'re onsite, to managers and to crew on the same site',
  pingInterval: 'Ping interval (minutes)',
  createDescription: 'Add someone who carries a company phone. You can pair the phone afterwards.',
  creating: 'Creating…',
  createEmployee: 'Create employee',
  created: 'Employee created.',
  editDescription: 'Edit employee',
  updated: 'Employee updated.',
  inviteNoValidEmail: 'No valid email address',
  inviteDuplicateEmail: 'Duplicate email',
}
